import { AsiDropdownService } from '../asi-dropdown.service';
import {
  TemplateRef,
  Component,
  ElementRef,
  ViewChild,
  HostListener,
  Inject,
  Input,
  Renderer2,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AsiDropDown } from '../asi-dropdown.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'asi-dropdown-container',
  host: { 'class': 'asi-component asi-dropdown-container' },
  templateUrl: 'asi-dropdown-container.component.html'
})
export class AsiDropdownContainer {

  private static BASE_INDEX = 125;

  index: number;
  canClose: Function;

  @Input() calculWidth = true;

  @ViewChild('drop', { read: ElementRef }) drop: ElementRef;

  private subjectContainer: Subject<AsiDropdownContainer> = new Subject();

  private asiDropDownService: AsiDropdownService;

  public template: TemplateRef<any>;
  private referenceElement: HTMLElement;

  constructor(@Inject(DOCUMENT) private document: any, private renderer: Renderer2, private elementRef: ElementRef) {}

  @HostListener('document:mouseup', ['$event'])
  documentClick(event: MouseEvent) {
    if (!this.drop.nativeElement.contains(event.target)) {
      this.asiDropDownService.canClose(this.index, this.canClose).subscribe(close => {
        if (close) {
          setTimeout(() => {
            this.close();
          });
        }
      })
    }
  }

  close() {
    this.subjectContainer.next(this);
    this.subjectContainer.complete();
  }

  // Close event when click outside
  onClose(): Observable<AsiDropdownContainer> {
    return this.subjectContainer.asObservable();
  }

  /**
   * Move the container under htmlElement
   * @param relativeTo The parent HTMLElement of the dropdown
   */
  forElement(relativeTo: any) {
    this.referenceElement = relativeTo;

    const rectRelativeTo = relativeTo.getBoundingClientRect();

    // Get the computed class margin (from both style + css class)
    const bodyComputedStyle = getComputedStyle(this.document.body);
    const bodyMarginTop = parseInt(bodyComputedStyle.marginTop.slice(0, -2), 10);

    // Get the computed class margin (from both style + css class)
    const parentComputedStyle = getComputedStyle(this.elementRef.nativeElement);

    const parentMarginTop = parseInt(parentComputedStyle.marginTop.slice(0, -2), 10);
    const parentMarginLeft = parseInt(parentComputedStyle.marginLeft.slice(0, -2), 10);

    const rectElement = this.elementRef.nativeElement.getBoundingClientRect();

    const screenVerticalPosition = rectRelativeTo.top - bodyMarginTop;
    if (screenVerticalPosition > this.document.body.clientHeight / 2) {
      // show over the element
      const bodyVerticalPosition = rectElement.bottom - rectRelativeTo.top + parentMarginTop;
      this.drop.nativeElement.style.bottom = bodyVerticalPosition + 'px';
      this.drop.nativeElement.style.marginBottom = '2px';
    } else {
      // show under the element
      const bodyVerticalPosition = - rectElement.top + rectRelativeTo.top - parentMarginTop + relativeTo.offsetHeight;
      this.drop.nativeElement.style.top = bodyVerticalPosition + 'px';
      this.drop.nativeElement.style.marginTop = '2px';
    }
    this.drop.nativeElement.style.left = rectRelativeTo.left - rectElement.left - parentMarginLeft + 'px';

    this.drop.nativeElement.style.width = relativeTo.offsetWidth + 'px';
  }

  /**
   * @param asiDrownDown The content to display in the container
   */
  show(asiDrownDown: AsiDropDown) {
    setTimeout(() => {
      this.template = asiDrownDown.contentTemplate;
      let visibility = this.drop.nativeElement.style.visibility;
      this.drop.nativeElement.style.visibility = 'hidden';
      if (asiDrownDown.dropDownClass) {
        this.renderer.addClass(this.elementRef.nativeElement, asiDrownDown.dropDownClass);
      }
      setTimeout(() => {
        const dropContainer = this.drop.nativeElement.getBoundingClientRect();
        if (dropContainer.right > this.document.documentElement.clientWidth) {
          this.drop.nativeElement.style.left =
            (this.drop.nativeElement.offsetLeft - dropContainer.right + this.document.documentElement.clientWidth) + 'px';
        }

        let dropRight = this.drop.nativeElement.offsetLeft + this.drop.nativeElement.offsetWidth;
        if (dropRight > this.document.documentElement.clientWidth) {
          this.drop.nativeElement.style.left = this.drop.nativeElement.offsetLeft
            + this.document.documentElement.scrollLeft - (dropRight - this.document.documentElement.clientWidth) + 'px';
        }
        this.drop.nativeElement.style.visibility = visibility;
      });
    });
  }

  public injectService(service: AsiDropdownService) {
    this.asiDropDownService = service;
  }

  public setIndex(index: number) {
    this.index = index;
    this.elementRef.nativeElement.style.zIndex = AsiDropdownContainer.BASE_INDEX + index;
  }

  public setCalculWidth(calculWidth: boolean) {
    if (calculWidth) {
      this.drop.nativeElement.style.width = this.referenceElement.offsetWidth + 'px';
    } else {
      this.drop.nativeElement.style.width = '';
    }
  }
}
